var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 709,
    viewBox: "0 0 630 709",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.828 708.301C440.443 708.301 551.192 686.153 551.192 658.832C551.192 631.511 440.443 609.363 303.828 609.363C167.212 609.363 56.4639 631.511 56.4639 658.832C56.4639 686.153 167.212 708.301 303.828 708.301Z",
    fill: "#92E3A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M303.828 708.301C440.443 708.301 551.192 686.153 551.192 658.832C551.192 631.511 440.443 609.363 303.828 609.363C167.212 609.363 56.4639 631.511 56.4639 658.832C56.4639 686.153 167.212 708.301 303.828 708.301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M566.431 0.75H388.075C381.982 0.75 377.043 5.68909 377.043 11.7818V208.396C377.043 214.489 381.982 219.428 388.075 219.428H566.431C572.523 219.428 577.462 214.489 577.462 208.396V11.7818C577.462 5.68909 572.523 0.75 566.431 0.75Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M388.075 0.750138H566.413C569.324 0.750138 572.116 1.90663 574.174 3.96519C576.233 6.02375 577.389 8.81576 577.389 11.727V23.1796H377.043V11.7819C377.036 10.3312 377.316 8.89336 377.868 7.55164C378.42 6.20992 379.232 4.9909 380.258 3.96505C381.284 2.93921 382.503 2.12689 383.845 1.57507C385.186 1.02324 386.624 0.742866 388.075 0.750138Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M387.965 117.507H468.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M387.965 127.917H468.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M387.965 138.328H468.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M387.965 148.737H468.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M387.965 159.146H468.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M387.965 169.574H468.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M387.965 179.984H468.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M387.965 190.395H468.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M387.965 200.804H468.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M482.787 117.507H563.431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M482.787 127.917H563.431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M482.787 138.328H563.431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M482.787 148.737H563.431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M482.787 159.146H563.431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M482.787 169.574H563.431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M482.787 179.984H563.431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M482.787 190.395H563.431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M482.787 200.804H563.431",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M441.898 51.5915C442.296 50.3554 442.505 49.0664 442.52 47.7679C442.52 43.0296 437.708 42.7551 432.988 42.7551H431.799V41.6392H452.399V42.7551C447.039 42.7551 445.081 46.1763 443.416 51.2439L432.439 84.0099C431.616 86.4431 430.921 88.2543 428.341 88.2543H428.122L418.462 56.9519L409.479 84.0831C408.638 86.5163 407.943 88.3275 405.363 88.3275H405.162L391.111 42.7551H386.172V41.6392H404.247V42.7551H399.106L409.534 78.6495H409.955L417.822 54.8114L414.163 42.8466H409.223V41.6392H427.317V42.7551H422.176L432.604 78.6495H433.007L441.898 51.5915Z",
    fill: "#92E3A9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M563.998 31.2661H481.013V106.275H563.998V31.2661Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M563.997 62.623C561.214 62.7816 558.449 63.1671 555.728 63.7756C543.123 66.5198 539.83 84.6134 525.578 84.6134C512.955 84.6134 511.876 67.6175 493.782 65.4222C489.38 64.7288 484.872 65.5273 480.976 67.6907V106.274H563.997V62.623Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M508.583 48.4268C508.586 50.2737 508.042 52.0802 507.018 53.6174C505.994 55.1545 504.537 56.3532 502.831 57.0617C501.126 57.7702 499.248 57.9565 497.436 57.5971C495.625 57.2376 493.961 56.3486 492.655 55.0427C491.349 53.7367 490.46 52.0725 490.1 50.2609C489.741 48.4493 489.927 46.5717 490.636 44.8661C491.344 43.1604 492.543 41.7034 494.08 40.6796C495.617 39.6558 497.424 39.1111 499.27 39.1148C501.74 39.1148 504.109 40.0959 505.855 41.8422C507.601 43.5886 508.583 45.9571 508.583 48.4268Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M567.785 7.31836H383.062V14.435H567.785V7.31836Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M556.259 263.062H476.292C473.148 263.062 470.133 264.311 467.909 266.534C465.686 268.757 464.437 271.772 464.437 274.917V317.69C464.437 320.834 465.686 323.849 467.909 326.073C470.133 328.296 473.148 329.545 476.292 329.545H478.744C476.256 335.033 471.426 343.449 463.797 348.443C463.797 348.443 480.024 347.309 496.929 329.545H556.222C559.366 329.545 562.382 328.296 564.605 326.073C566.828 323.849 568.077 320.834 568.077 317.69V274.917C568.077 271.779 566.833 268.769 564.618 266.547C562.403 264.324 559.397 263.071 556.259 263.062Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M502.528 294.784C502.531 293.574 502.175 292.39 501.505 291.382C500.835 290.375 499.881 289.589 498.764 289.124C497.647 288.659 496.417 288.537 495.23 288.772C494.042 289.007 492.952 289.589 492.096 290.445C491.241 291.301 490.658 292.391 490.423 293.578C490.188 294.765 490.311 295.995 490.775 297.113C491.24 298.23 492.026 299.184 493.034 299.854C494.041 300.524 495.225 300.88 496.435 300.876C498.05 300.871 499.596 300.228 500.738 299.086C501.879 297.945 502.523 296.398 502.528 294.784Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M523.255 294.784C523.255 293.579 522.897 292.401 522.228 291.399C521.559 290.398 520.607 289.617 519.494 289.156C518.381 288.695 517.156 288.574 515.974 288.809C514.792 289.044 513.707 289.624 512.855 290.476C512.003 291.328 511.422 292.414 511.187 293.596C510.952 294.777 511.073 296.002 511.534 297.115C511.995 298.229 512.776 299.18 513.778 299.85C514.78 300.519 515.958 300.876 517.162 300.876C518.777 300.871 520.324 300.228 521.465 299.087C522.606 297.945 523.25 296.398 523.255 294.784Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M544.001 294.784C544.005 293.575 543.649 292.392 542.98 291.384C542.311 290.377 541.358 289.591 540.242 289.126C539.126 288.66 537.896 288.537 536.71 288.77C535.523 289.004 534.433 289.585 533.576 290.439C532.72 291.292 532.136 292.381 531.899 293.567C531.662 294.753 531.782 295.982 532.244 297.1C532.706 298.217 533.489 299.173 534.494 299.845C535.499 300.517 536.681 300.876 537.891 300.876C539.507 300.871 541.055 300.229 542.2 299.088C543.344 297.947 543.992 296.4 544.001 294.784Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M116.507 26.6909H248.229C251.364 26.6909 254.37 27.9361 256.586 30.1525C258.803 32.3688 260.048 35.3749 260.048 38.5094V129.819H104.743V38.5094C104.743 35.3844 105.981 32.3866 108.185 30.1718C110.39 27.957 113.382 26.7054 116.507 26.6909Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M259.975 115.092H104.743V129.764H259.975V115.092Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M252.877 120.104H111.86V124.751H252.877V120.104Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M182.368 94.9309C194.21 94.9309 203.81 85.3312 203.81 73.4894C203.81 61.6475 194.21 52.0479 182.368 52.0479C170.526 52.0479 160.927 61.6475 160.927 73.4894C160.927 85.3312 170.526 94.9309 182.368 94.9309Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M172.69 60.1519L195.833 73.5071L172.69 86.8623V60.1519Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M192.833 167.323H45.5048C42.6555 167.323 40.3457 169.633 40.3457 172.482V228.629C40.3457 231.478 42.6555 233.788 45.5048 233.788H192.833C195.682 233.788 197.992 231.478 197.992 228.629V172.482C197.992 169.633 195.682 167.323 192.833 167.323Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1159 176.379L59.8843 177.66C56.4083 179.599 53.1701 183.002 53.1701 186.99C53.1256 187.675 53.2183 188.362 53.4427 189.011C53.6672 189.66 54.0189 190.257 54.4772 190.768C54.9356 191.28 55.4913 191.694 56.1119 191.988C56.7325 192.281 57.4055 192.448 58.0914 192.478C58.6036 192.478 58.9512 192.222 58.9512 191.71C58.9512 191.198 58.6951 191.033 58.1829 190.942C57.4921 190.754 56.8902 190.328 56.4848 189.738C56.0793 189.148 55.8966 188.434 55.9692 187.722C55.9825 187.154 56.1112 186.594 56.3475 186.077C56.5838 185.561 56.9228 185.097 57.3438 184.716C57.7648 184.334 58.259 184.042 58.7964 183.858C59.3337 183.673 59.9031 183.6 60.4697 183.642C61.0861 183.644 61.6958 183.77 62.2628 184.012C62.8298 184.254 63.3425 184.607 63.7706 185.05C64.1987 185.494 64.5336 186.018 64.7553 186.594C64.9771 187.169 65.0813 187.783 65.0617 188.399C65.0527 189.173 64.8879 189.937 64.5769 190.647C64.2659 191.356 63.8152 191.995 63.2517 192.526C62.6881 193.057 62.0234 193.469 61.2971 193.737C60.5708 194.006 59.7979 194.125 59.0244 194.088C58.0629 194.151 57.099 194.01 56.1951 193.676C55.2913 193.342 54.4678 192.822 53.7779 192.149C53.088 191.476 52.5471 190.666 52.1902 189.771C51.8334 188.876 51.6686 187.916 51.7065 186.953C51.6516 182.325 55.2191 178.593 59.1159 176.379ZM74.8311 176.379L75.5995 177.66C72.1052 179.599 68.8853 183.002 68.8853 186.99C68.8383 187.676 68.9292 188.364 69.1527 189.014C69.3762 189.663 69.7278 190.262 70.1866 190.774C70.6454 191.285 71.2022 191.7 71.8239 191.993C72.4457 192.285 73.1199 192.451 73.8066 192.478C74.3189 192.478 74.6665 192.222 74.6665 191.71C74.6665 191.198 74.4103 191.033 73.8981 190.942C73.2073 190.754 72.6055 190.328 72.2 189.738C71.7945 189.148 71.6118 188.434 71.6844 187.722C71.6951 187.153 71.8221 186.592 72.0575 186.074C72.2929 185.556 72.6319 185.092 73.0534 184.71C73.475 184.328 73.9702 184.036 74.5088 183.852C75.0473 183.668 75.6177 183.597 76.1849 183.642C76.8013 183.644 77.4111 183.77 77.978 184.012C78.545 184.254 79.0577 184.607 79.4858 185.05C79.914 185.494 80.2488 186.018 80.4706 186.594C80.6923 187.169 80.7965 187.783 80.7769 188.399C80.7655 189.172 80.5989 189.935 80.287 190.643C79.9751 191.351 79.5244 191.989 78.9614 192.52C78.3984 193.051 77.7347 193.463 77.0095 193.732C76.2843 194.002 75.5125 194.123 74.7396 194.088C73.7788 194.148 72.8161 194.005 71.9136 193.67C71.0111 193.335 70.1887 192.815 69.4994 192.143C68.8101 191.471 68.2691 190.662 67.9113 189.768C67.5535 188.874 67.3867 187.915 67.4217 186.953C67.3485 182.325 70.916 178.593 74.8311 176.379Z",
    fill: "#92E3A9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8701 189.917H179.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8701 197.619H179.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8701 205.322H179.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8701 213.042H179.588",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M163.713 336.842C182.231 333.819 194.793 316.357 191.77 297.839C188.748 279.321 171.286 266.76 152.768 269.782C134.25 272.805 121.688 290.267 124.711 308.785C127.733 327.303 145.195 339.864 163.713 336.842Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M179.789 322.267C190.237 310.371 189.062 292.257 177.166 281.81C165.269 271.362 147.156 272.537 136.708 284.433C126.261 296.33 127.435 314.443 139.332 324.891C151.228 335.338 169.342 334.164 179.789 322.267Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M158.256 282.58V303.308H172.27",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M370.805 303.383C370.805 303.383 390.289 344.967 390.289 347.162C390.289 349.357 373 358.761 369.707 360.737C367.153 362.192 364.521 363.505 361.822 364.67L363.798 383.935C363.798 383.935 393.564 377.147 406.041 370.36C418.518 363.572 418.079 355.907 415.188 344.528C412.298 333.148 393.07 289.167 393.07 289.167L370.805 303.383Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_887_2574",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 361,
    y: 289,
    width: 56,
    height: 95
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M370.805 303.382C370.805 303.382 390.289 344.966 390.289 347.161C390.289 349.356 373 358.76 369.707 360.736C367.153 362.191 364.521 363.504 361.822 364.669L363.798 383.934C363.798 383.934 393.564 377.146 406.041 370.359C418.518 363.571 418.079 355.906 415.188 344.527C412.298 333.147 393.07 289.167 393.07 289.167L370.805 303.382Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_887_2574)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M405.986 370.359C418.463 363.571 418.024 355.906 415.133 344.527C412.243 333.147 393.015 289.167 393.015 289.167L389.905 291.142L388.917 292.972C388.917 292.972 406.864 337.026 407.943 351.698C408.675 361.559 388.825 373.853 375.708 380.878C385.441 378.299 398.686 374.329 405.986 370.359Z",
    fill: "#92E3A9"
  })))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M370.805 303.383C370.805 303.383 390.289 344.967 390.289 347.162C390.289 349.357 373 358.761 369.707 360.737C367.153 362.192 364.521 363.505 361.822 364.67L363.798 383.935C363.798 383.935 393.564 377.147 406.041 370.36C418.518 363.572 418.079 355.907 415.188 344.528C412.298 333.148 393.07 289.167 393.07 289.167L370.805 303.383Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M230.227 294.199C230.227 294.199 216.012 346.284 215.592 355.486C215.171 364.689 243.82 382.837 244.863 383.935C245.906 385.032 243.235 352.285 243.235 352.285L252.949 304.718L230.227 294.199Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_887_2574",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 215,
    y: 294,
    width: 38,
    height: 90
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M230.227 294.2C230.227 294.2 216.012 346.285 215.592 355.487C215.171 364.69 243.82 382.838 244.863 383.936C245.906 385.033 243.235 352.286 243.235 352.286L252.949 304.719L230.227 294.2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_887_2574)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M236.74 298.462L236.429 297.054L230.227 294.2C230.227 294.2 216.012 346.285 215.592 355.487C215.171 364.69 243.82 382.838 244.863 383.936C245.284 384.375 245.119 379.472 244.772 373.416C236.246 366.19 224.007 356.018 222.58 351.737",
    fill: "#92E3A9"
  })))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M230.227 294.199C230.227 294.199 216.012 346.284 215.592 355.486C215.171 364.689 243.82 382.837 244.863 383.935C245.906 385.032 243.235 352.285 243.235 352.285L252.949 304.718L230.227 294.199Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M296.986 241.875C296.986 241.875 291.497 245.827 280.795 246.266C270.092 246.705 269.58 238.948 256.28 238.948C240.162 238.948 219.946 289.936 219.946 289.936C219.946 289.936 230.008 299.796 239.869 303.949C245.324 306.339 251.059 308.03 256.938 308.98L258.475 342.478H367.037L368.335 308.98L402.272 286.972C402.272 286.972 385.624 257.206 377.538 246.046C369.451 234.887 355.858 239.039 351.705 241.875C347.553 244.711 335.24 245.388 330.703 244.729C324.784 243.419 318.935 241.813 313.177 239.918C313.177 239.918 306.188 234.1 296.986 241.875Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M258.036 253.694L257.597 309.292",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M261.969 258.743C261.969 258.743 263.506 285.874 269.287 300.985",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M270.293 303.163C271.542 306.851 273.077 310.435 274.885 313.883",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M265.464 255.67C267.541 265.535 270.473 275.201 274.227 284.557",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M359.828 260.481C359.828 260.481 354.577 281.941 349.967 291.583",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M368.335 309.072L368.115 265.732",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M365.939 266.61C365.939 266.61 361.987 294.052 352.364 308.413",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M361.127 302.944C361.127 302.944 356.736 311.268 353.681 315.64",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M290.856 245.168C290.856 245.168 293.93 263.994 298.302 273.617C302.675 283.24 310.34 285.216 316.908 282.38C323.476 279.544 328.288 265.512 327.885 247.62",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M275.325 205.762C275.325 205.762 271.154 198.554 267.879 202.268C264.604 205.982 270.513 214.525 273.788 217.361C277.063 220.197 279.478 218.459 279.276 215.403C279.075 212.348 275.325 205.762 275.325 205.762Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M275.325 205.762C275.325 205.762 271.154 198.554 267.879 202.268C264.604 205.982 270.513 214.525 273.788 217.361C277.063 220.197 279.478 218.459 279.276 215.403C279.075 212.348 275.325 205.762 275.325 205.762Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M275.325 205.762C275.325 205.762 271.154 198.554 267.879 202.268C264.604 205.982 270.513 214.525 273.788 217.361C277.063 220.197 279.478 218.459 279.276 215.403C279.075 212.348 275.325 205.762 275.325 205.762Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M341.534 205.762C341.534 205.762 345.687 198.554 348.98 202.268C352.273 205.982 346.345 214.525 343.071 217.361C339.796 220.197 337.363 218.459 337.582 215.403C337.802 212.348 341.534 205.762 341.534 205.762Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M341.534 205.762C341.534 205.762 345.687 198.554 348.98 202.268C352.273 205.982 346.345 214.525 343.071 217.361C339.796 220.197 337.363 218.459 337.582 215.403C337.802 212.348 341.534 205.762 341.534 205.762Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M341.534 205.762C341.534 205.762 345.687 198.554 348.98 202.268C352.273 205.982 346.345 214.525 343.071 217.361C339.796 220.197 337.363 218.459 337.582 215.403C337.802 212.348 341.534 205.762 341.534 205.762Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M295.01 240.357C297.076 249.699 299.709 258.906 302.895 267.927C306.846 277.77 314.274 277.77 317.348 271.421C320.421 265.073 322.379 241.418 322.379 241.418C322.379 241.418 301.797 244.29 295.01 240.357Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M275.764 208.176C275.764 208.176 281.453 228.3 292.229 240.137C303.005 251.974 306.865 254.773 312.591 253.913C318.317 253.053 324.41 245.607 332.935 230.13C341.46 214.652 342.082 202.779 342.796 201.681C343.509 200.584 340.966 178.703 328.782 169.281C316.598 159.859 302.95 155.725 291.131 166.006C279.313 176.288 271.812 193.064 275.764 208.176Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_887_2574",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 274,
    y: 160,
    width: 69,
    height: 95
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M275.764 208.175C275.764 208.175 281.453 228.299 292.229 240.136C303.005 251.973 306.865 254.772 312.591 253.912C318.317 253.052 324.41 245.606 332.935 230.129C341.46 214.651 342.082 202.778 342.796 201.68C343.509 200.583 340.966 178.702 328.782 169.28C316.598 159.858 302.95 155.724 291.131 166.006C279.313 176.287 271.812 193.064 275.764 208.175Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_887_2574)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M328.727 169.207C316.47 159.804 302.895 155.651 291.076 165.933C279.258 176.214 271.812 193.064 275.764 208.175C275.764 208.175 276.843 212.054 278.984 217.323C278.977 216.648 279.07 215.976 279.258 215.329C281.874 207.041 289.595 190.997 315.573 198.351C336.21 204.169 333.685 222.317 331.764 231.995L332.88 229.983C341.424 214.451 342.028 202.632 342.741 201.534C343.455 200.437 340.985 178.629 328.727 169.207Z",
    fill: "#92E3A9"
  })))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M275.764 208.176C275.764 208.176 281.453 228.3 292.229 240.137C303.005 251.974 306.865 254.773 312.591 253.913C318.317 253.053 324.41 245.607 332.935 230.13C341.46 214.652 342.082 202.779 342.796 201.681C343.509 200.584 340.966 178.703 328.782 169.281C316.598 159.859 302.95 155.725 291.131 166.006C279.313 176.288 271.812 193.064 275.764 208.176Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M312.536 218.678C311.858 222.951 311.491 227.268 311.439 231.594C311.658 235.967 312.975 237.284 311 237.723C309.024 238.162 306.847 235.089 306.847 235.089",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M290.637 222.19C291.905 223.106 293.42 223.617 294.984 223.656C296.548 223.695 298.087 223.261 299.4 222.409",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M318.445 222.19C319.711 223.104 321.223 223.615 322.784 223.654C324.344 223.693 325.881 223.259 327.19 222.409",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M304.614 214.818C304.614 214.818 300.443 204.518 286.667 209.329",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M316.085 213.555C316.085 213.555 319.579 203.475 332.056 209.384",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M307.267 222.94C307.267 228.575 300.809 233.13 292.833 233.13C284.856 233.13 278.38 228.575 278.38 222.94C278.38 217.305 284.417 214.963 292.394 214.963C300.37 214.963 307.267 217.323 307.267 222.94Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M340.546 222.94C340.546 228.575 334.069 233.13 326.093 233.13C318.116 233.13 311.658 228.575 311.658 222.94C311.658 217.305 317.677 214.963 325.654 214.963C333.63 214.963 340.546 217.323 340.546 222.94Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M156.079 398.442L155.183 620.23C155.183 620.929 155.46 621.599 155.954 622.093C156.448 622.587 157.118 622.865 157.817 622.865C158.498 622.865 159.153 622.599 159.642 622.125C160.13 621.65 160.414 621.003 160.433 620.322L166.763 398.753L156.079 398.442Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M141.15 450.29L140.29 679.579C140.288 679.925 140.354 680.269 140.486 680.59C140.617 680.911 140.811 681.202 141.056 681.447C141.301 681.692 141.593 681.886 141.914 682.018C142.234 682.149 142.578 682.216 142.925 682.213C143.605 682.214 144.259 681.951 144.75 681.481C145.241 681.01 145.531 680.368 145.559 679.689L151.871 450.583L141.15 450.29Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M462.7 398.442L463.597 620.23C463.599 620.575 463.533 620.918 463.403 621.237C463.272 621.557 463.08 621.847 462.837 622.092C462.594 622.337 462.304 622.531 461.986 622.664C461.667 622.796 461.325 622.865 460.98 622.865C460.297 622.865 459.641 622.6 459.149 622.126C458.658 621.651 458.37 621.004 458.346 620.322L452.034 398.753L462.7 398.442Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M477.646 450.29L478.543 679.579C478.545 679.925 478.478 680.269 478.347 680.59C478.215 680.911 478.021 681.202 477.776 681.447C477.531 681.692 477.24 681.886 476.919 682.018C476.598 682.149 476.255 682.216 475.908 682.213C475.23 682.214 474.578 681.951 474.09 681.48C473.602 681.009 473.316 680.366 473.292 679.689L466.962 450.583L477.646 450.29Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M245.102 459.822L244.571 663.333C244.513 663.841 244.654 664.351 244.965 664.757C245.275 665.163 245.731 665.433 246.236 665.51C246.729 665.442 247.178 665.188 247.491 664.801C247.803 664.413 247.957 663.921 247.919 663.425L251.889 460.06L245.102 459.822Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M373.915 453.271L374.409 630.877C374.451 631.307 374.326 631.737 374.061 632.077C373.795 632.418 373.409 632.643 372.982 632.707C372.556 632.643 372.171 632.417 371.909 632.076C371.646 631.735 371.526 631.305 371.573 630.877L368.188 453.418L373.915 453.271Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M243.107 453.271L243.601 630.877C243.643 631.307 243.519 631.737 243.253 632.077C242.988 632.418 242.601 632.643 242.174 632.707C241.748 632.643 241.364 632.417 241.101 632.076C240.838 631.735 240.718 631.305 240.765 630.877L237.381 453.418L243.107 453.271Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M370.238 459.822L370.805 663.333C370.863 663.841 370.722 664.351 370.412 664.757C370.101 665.163 369.646 665.433 369.14 665.51C368.649 665.438 368.203 665.183 367.891 664.796C367.579 664.41 367.424 663.92 367.457 663.425L363.487 460.06L370.238 459.822Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M306.773 474.073C351.736 474.073 388.185 465.743 388.185 455.467C388.185 445.191 351.736 436.861 306.773 436.861C261.811 436.861 225.361 445.191 225.361 455.467C225.361 465.743 261.811 474.073 306.773 474.073Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M267.128 613.406C267.128 613.406 262.866 619.517 265.921 622.554C268.976 625.591 272.013 624.383 271.702 627.438C271.391 630.494 266.525 640.848 262.262 651.825C257.999 662.802 266.836 673.779 275.068 670.742C283.301 667.705 282.386 637.189 283.594 631.701C284.801 626.213 285.734 625.298 285.423 620.12C285.112 614.943 284.819 609.455 280.849 608.833C276.879 608.21 268.958 611.284 267.128 613.406Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M280.209 662.326C274.72 660.24 266.305 660.661 261.566 661.137C263.158 668.034 269.25 672.882 275.068 670.741C277.501 669.845 279.093 666.589 280.209 662.326Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M257.688 599.996C257.688 599.996 266.525 614.943 268.958 618.895C271.391 622.846 279.642 621.639 280.557 616.15C281.472 610.662 277.191 595.422 277.191 595.422L258.896 599.996H257.688Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M236.649 576.213C236.649 576.213 234.198 580.183 235.423 582.927C236.649 585.671 239.997 593.593 242.137 597.563C244.278 601.533 254.029 603.966 265.299 602.136C276.568 600.307 282.99 595.111 283.301 590.537C283.612 585.964 281.471 579.872 279.935 572.554C278.398 565.236 274.446 565.547 268.958 565.547C263.469 565.547 241.223 571.95 236.649 576.213Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M269.58 486.568C269.744 479.067 274.08 475.372 274.41 470.231C274.926 463.435 274.364 456.6 272.745 449.979L264.402 438.581C240.4 438.892 223.203 439.295 222.928 439.386C222.013 439.679 221.391 444.875 220.788 449.137C220.788 449.137 210.597 450.436 212.427 478.793C212.683 482.745 222.965 528.463 223.715 533.677C228.288 565.529 238.479 581.482 238.479 581.482C238.479 581.482 239.393 585.452 251.285 584.537C263.177 583.622 275.068 575.701 275.068 575.701C275.068 575.701 268.958 513.7 269.58 486.568Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M219.141 444.491C219.141 444.491 206.536 446.32 198.815 455.138C191.095 463.956 197.644 469.774 212.646 468.201C227.648 466.627 244.955 451.278 245.687 450.455C246.418 449.631 230.044 439.203 219.141 444.491Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M241.516 449.978C249.547 450.392 257.515 451.617 265.299 453.637C275.672 456.693 293.967 462.785 298.23 462.785C302.492 462.785 301.285 446.923 301.285 443.886C301.285 440.849 246.4 439.001 239.686 439.001C232.972 439.001 241.516 449.978 241.516 449.978Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M301.285 443.887C301.285 443.887 296.4 446.32 294.571 455.468C292.741 464.615 290.308 469.5 293.967 471.933C297.626 474.366 313.487 476.196 315.921 473.762C318.354 471.329 325.068 459.127 326.294 451.205C327.52 443.283 301.285 443.887 301.285 443.887Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M322.013 446.924C319.177 450.178 316.913 453.89 315.317 457.901C314.024 462.099 313.003 466.377 312.262 470.707C318.098 472.307 323.805 474.35 329.331 476.817C339.1 481.08 355.565 484.135 371.409 487.794C387.252 491.453 391.533 495.112 397.021 495.112C402.51 495.112 409.224 490.831 417.768 480.476C426.312 470.122 418.975 448.149 410.45 441.435C401.925 434.721 356.169 429.251 350.077 431.08C343.985 432.91 322.013 446.924 322.013 446.924Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M207.597 468.366C206.392 462.893 203.951 457.768 200.462 453.382C199.895 453.913 199.346 454.462 198.815 455.065C192.028 462.786 196.272 468.274 207.597 468.366Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M268.647 473.194C268.647 473.194 262.354 540.538 249.511 551.02",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M264.201 537.117C264.201 537.117 259.206 559.07 246.107 567.797",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M345.192 460.956C345.192 460.956 325.672 462.182 338.478 470.707C351.284 479.233 374.464 484.739 374.464 484.739",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M486.904 437.886L480.318 431.959L465.096 399.028C464.374 397.53 463.241 396.268 461.828 395.391C460.416 394.513 458.783 394.055 457.12 394.07H161.476C159.81 394.051 158.173 394.508 156.757 395.386C155.341 396.264 154.204 397.527 153.481 399.028L134.509 440.045L131.381 438.893V448.278L131.527 448.168C131.714 449.42 132.349 450.562 133.315 451.38C134.281 452.198 135.512 452.636 136.778 452.614H481.799C483.133 452.644 484.425 452.156 485.405 451.251C486.385 450.347 486.974 449.097 487.05 447.766L486.904 437.886Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M481.8 444.033H136.778C135.924 444.067 135.075 443.884 134.311 443.5C133.547 443.116 132.893 442.544 132.41 441.839C131.927 441.133 131.632 440.316 131.551 439.465C131.47 438.613 131.607 437.756 131.948 436.972L153.481 390.448C154.201 388.944 155.337 387.678 156.754 386.8C158.17 385.921 159.809 385.467 161.476 385.49H457.12C458.784 385.47 460.419 385.926 461.832 386.805C463.246 387.683 464.378 388.947 465.097 390.448L486.63 436.972C486.971 437.756 487.108 438.613 487.027 439.465C486.947 440.316 486.651 441.133 486.168 441.839C485.686 442.544 485.032 443.116 484.267 443.5C483.503 443.884 482.654 444.067 481.8 444.033Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M154.25 412.785C154.25 412.785 146.438 418.146 151.322 420.103C156.207 422.061 212.354 420.597 219.196 418.64C226.038 416.682 233.832 398.625 233.832 395.698C233.832 392.771 223.989 390.667 220.367 390.502C216.745 390.338 168.885 393.247 168.885 393.247L154.25 412.785Z",
    fill: "#92E3A9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M433.538 422.061C444.592 422.061 453.552 418.342 453.552 413.755C453.552 409.168 444.592 405.449 433.538 405.449C422.484 405.449 413.523 409.168 413.523 413.755C413.523 418.342 422.484 422.061 433.538 422.061Z",
    fill: "#92E3A9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M306.114 432.325C345.752 432.325 377.885 426.312 377.885 418.896C377.885 411.48 345.752 405.468 306.114 405.468C266.476 405.468 234.344 411.48 234.344 418.896C234.344 426.312 266.476 432.325 306.114 432.325Z",
    fill: "#92E3A9"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M418.902 381.081C418.902 381.081 417.584 375.83 413.212 377.586C408.839 379.343 409.279 390.942 410.138 397.51C410.998 404.077 416.926 401.004 416.926 401.004V397.07C416.926 397.07 414.749 398.808 413.651 396.412C412.553 394.015 412.773 381.959 413.871 382.179C414.968 382.398 417.145 386.112 417.145 386.112C417.145 386.112 417.804 385.691 418.902 381.081Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M415.755 381.959V410.718C415.755 414.103 423.53 416.847 433.135 416.847C442.74 416.847 450.497 414.103 450.497 410.718V381.959H415.755Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M450.497 381.958C450.497 384.885 442.721 387.245 433.135 387.245C423.548 387.245 415.755 384.885 415.755 381.958C415.755 379.031 423.53 376.671 433.135 376.671C442.74 376.671 450.497 379.049 450.497 381.958Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M448.228 381.959C448.228 384.502 441.459 386.551 433.135 386.551C424.811 386.551 418.023 384.502 418.023 381.959C418.023 379.416 424.793 377.367 433.135 377.367C441.477 377.367 448.228 379.416 448.228 381.959Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M421.481 384.886C429.086 387.105 437.166 387.105 444.771 384.886C437.166 382.666 429.086 382.666 421.481 384.886Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M152.091 395.095L152.31 404.938L218.629 405.596V394.217L152.091 395.095Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M218.629 405.595L228.27 384.812V378.684L218.189 396.192L218.629 405.595Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M152.091 404.059L152.31 413.92L218.629 414.578V403.199L152.091 404.059Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M218.629 414.578L228.27 393.777V387.648L218.189 405.157L218.629 414.578Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M177.703 370.14C177.703 370.14 179.24 367.085 177.045 365.767C174.849 364.45 172.453 367.597 171.135 368.603C169.818 369.609 142.248 387.868 141.37 390.722C140.492 393.575 141.37 399.869 147.279 400.564C153.188 401.259 158.439 397.289 161.073 396.631C163.708 395.972 164.732 395.753 164.732 395.753L182.899 371.238L177.703 370.14Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M147.279 400.583C153.188 401.241 158.439 397.308 161.073 396.649C163.708 395.991 164.732 395.771 164.732 395.771L165.391 394.875L148.322 391.399C147.394 390.525 146.201 389.985 144.932 389.866C143.662 389.747 142.39 390.054 141.315 390.74C140.492 393.558 141.37 399.906 147.279 400.583Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M148.377 391.436H199.602C215.592 391.436 220.404 390.557 220.404 390.557L230.246 370.195C230.246 370.195 199.145 372.171 189.54 371.512C185.571 371.398 181.619 370.958 177.722 370.195L148.377 391.436Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M148.377 391.435L149.255 395.368C149.255 395.368 190.839 395.588 201.779 395.588C212.72 395.588 221.044 396.027 221.044 396.027L220.385 390.539L148.377 391.435Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M221.043 395.973L230.227 374.952V370.141L220.385 390.503L221.043 395.973Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M368.793 420.56H243.382C243.104 420.563 242.829 420.51 242.571 420.406C242.314 420.301 242.08 420.146 241.882 419.951C241.685 419.755 241.529 419.522 241.422 419.266C241.315 419.009 241.26 418.734 241.26 418.457C241.26 418.179 241.315 417.904 241.422 417.647C241.529 417.391 241.685 417.158 241.882 416.962C242.08 416.767 242.314 416.612 242.571 416.507C242.829 416.403 243.104 416.35 243.382 416.353H368.793C369.07 416.35 369.344 416.403 369.601 416.508C369.857 416.613 370.09 416.768 370.286 416.963C370.482 417.159 370.637 417.392 370.742 417.649C370.846 417.905 370.899 418.18 370.897 418.457C370.899 418.733 370.846 419.008 370.742 419.265C370.637 419.521 370.482 419.754 370.286 419.95C370.09 420.146 369.857 420.3 369.601 420.405C369.344 420.51 369.07 420.563 368.793 420.56Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M369.853 416.316H242.302C241.835 416.317 241.386 416.14 241.046 415.82C240.705 415.5 240.5 415.063 240.472 414.597L233.539 331.264C233.507 331.006 233.532 330.744 233.609 330.496C233.687 330.248 233.817 330.02 233.99 329.826C234.163 329.632 234.376 329.477 234.613 329.372C234.851 329.267 235.108 329.213 235.368 329.215H376.805C377.065 329.213 377.322 329.267 377.56 329.372C377.798 329.477 378.01 329.632 378.183 329.826C378.356 330.02 378.486 330.248 378.564 330.496C378.642 330.744 378.666 331.006 378.635 331.264L371.701 414.597C371.673 415.066 371.465 415.506 371.121 415.826C370.777 416.146 370.323 416.322 369.853 416.316Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M318.116 374.202C318.116 379.179 312.719 383.203 306.078 383.203C299.437 383.203 294.021 379.179 294.021 374.202C294.021 369.226 299.418 365.22 306.078 365.22C312.737 365.22 318.116 369.245 318.116 374.202Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M442.759 309.109C444.715 307.583 446.09 305.433 446.656 303.017C447.067 301.205 447.023 299.319 446.528 297.528",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M428.159 374.348C428.159 374.348 440.325 367.03 436.355 358.669C432.385 350.309 418.957 344.765 418.957 331.739C418.957 320.506 430.903 316.354 438.697 311.853",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M439.392 374.11C439.392 374.11 446.179 369.592 446.179 362.42C446.179 357.609 441.038 354.462 434.251 346.723",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M430.5 342.04C430.5 342.04 426.055 338.545 429.33 331.978",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M327.501 150.401C329.678 149.944 334.343 148.151 337.49 140.852C337.538 140.741 337.564 140.622 337.567 140.502C337.569 140.381 337.547 140.261 337.503 140.149C337.459 140.037 337.393 139.934 337.309 139.848C337.225 139.761 337.125 139.692 337.014 139.644C336.79 139.551 336.539 139.549 336.314 139.638C336.089 139.726 335.907 139.899 335.807 140.12C332.916 146.816 328.781 148.297 327.062 148.627C330.139 144.902 331.839 140.231 331.873 135.4C331.873 122.703 320.11 112.421 305.602 112.421C291.094 112.421 279.331 122.703 279.331 135.4C279.341 140.036 280.884 144.539 283.721 148.206C280.959 148.06 276.294 149.231 270.384 156.128C270.216 156.302 270.121 156.535 270.121 156.777C270.121 157.02 270.216 157.253 270.384 157.427C270.554 157.568 270.768 157.645 270.988 157.646C271.121 157.646 271.253 157.617 271.373 157.56C271.493 157.503 271.599 157.42 271.683 157.317C279.239 148.517 284.234 149.999 285.24 150.401C283.532 151.341 281.93 152.464 280.465 153.749C272.031 161.342 266.89 175.703 267.549 187.668C268.289 195.603 271.166 203.19 275.873 209.622C281.998 205.238 287.078 199.552 290.747 192.973C293.481 188.141 295.924 183.15 298.064 178.027C298.064 183.387 298.76 189.863 301.577 194.492C303.609 198.148 306.587 201.191 310.198 203.302C313.809 205.413 317.921 206.515 322.104 206.493C323.548 206.514 324.99 206.373 326.403 206.072C326.527 206.041 326.644 205.985 326.744 205.906C326.845 205.827 326.928 205.728 326.989 205.615C334.05 207.115 341.076 206.987 342.155 205.487C343.893 203.09 346.363 195.608 347.186 186.46C348.686 170.946 338.917 157.481 327.501 150.401ZM303.278 193.376C299.729 187.576 299.839 178.118 300.26 172.684L300.498 172.062C300.666 177.651 302.091 183.13 304.666 188.092C307.241 193.055 310.9 197.375 315.371 200.73C317.842 202.438 320.581 203.718 323.476 204.517C318.994 204.828 309.773 203.969 303.278 193.376Z",
    fill: "#263238"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M303.59 164.58C303.59 164.58 302.09 175.666 316.177 186.533C330.264 197.4 343.619 193.119 343.619 193.119",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M305.657 160.921C305.657 160.921 320.494 182.527 340.985 176.892",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M298.321 153.731C295.982 152.543 293.36 152.021 290.744 152.221C288.127 152.421 285.616 153.336 283.484 154.866C275.599 160.116 271.647 172.52 271.647 172.52",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M298.706 159.75C298.706 159.75 292.321 158.049 288.369 162.001C286.443 163.746 284.796 165.776 283.484 168.02",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog3);
export default __webpack_public_path__ + "static/media/Blog3.51610094335b5791507606d171317bd2.svg";
export { ForwardRef as ReactComponent };